import { List } from 'immutable';
import { founderConstants } from '../constants';

export function founders(state = {}, action) {
  switch (action.type) {
    case founderConstants.FOUNDER_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case founderConstants.FOUNDER_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case founderConstants.FOUNDER_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case founderConstants.FOUNDER_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case founderConstants.FOUNDER_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case founderConstants.FOUNDER_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case founderConstants.FOUNDER_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case founderConstants.FOUNDER_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const founderIndex = state.items.findIndex(val => val.id == action.response.id);

      if (founderIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(founderIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case founderConstants.FOUNDER_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case founderConstants.FOUNDER_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case founderConstants.FOUNDER_DELETE_SUCCESS: {
      const { founderId } = action;

      if (!state.items) {
        return state;
      }

      const founderIndex = state.items.findIndex(val => val.id == founderId);

      if (founderIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(founderIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case founderConstants.FOUNDER_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case founderConstants.FOUNDER_ERROR_RELOAD:
      return {
        ...state,
        createError: false,
        editError: action.error
      };

    default:
      return state;
  }
}
